import { MarketLayoutStylesSchema } from './MarketLayout.styles';

export const matchDetailsStyles: MarketLayoutStylesSchema = {
  headerText: {
    flex: '1',
    color: 'white',
    align: 'center',
    fontSize: '2xs',
    fontWeight: 'bold',
    fontFamily: 'accent',
  },
  rowWrapper: {
    mx: '0.5',
    px: '2',
    py: '2',
    alignItems: 'center',
    display: 'flex',
    fontSize: 'xs',
    fontWeight: 'bold',
    justifyContent: 'space-between',
    borderColor: 'transparent',
    borderTopWidth: undefined,
    fontFamily: 'accent',
    gap: '2',
    pos: 'relative',
    color: 'white',
    _before: {
      borderColor: 'blackAlpha.400',
      borderBottomWidth: '1px',
      boxShadow: '0 1px rgba(255, 255, 255, .07)',
      content: '""',
      w: 'full',
      left: '0',
      pos: 'absolute',
      top: '-1px',
    },
  },
  rowWrapperFirst: {
    borderTopWidth: '1px',
    px: '2',
    _before: {
      display: 'none',
    },
    sx: {
      button: {
        minW: '54px',
        px: 2,
        lineHeight: 'normal',
      },
    },
  },
  rowWrapperWithBtn: {
    borderColor: 'rgba(0, 0, 0, 0.1)',
    borderTopWidth: '1px',
  },
  tab: {
    bg: 'beta.500',
    color: 'white',
    fontSize: '2xs',
    fontWeight: 'extrabold',
    _notFirst: { borderLeftWidth: '1px', borderLeftColor: 'blackAlpha.400' },
    _selected: {
      bg: 'rgba(0, 0, 0, 0.36)',
      borderBottomColor: 'alpha.300',
      borderBottomWidth: '2px',
      color: 'alpha.300',
      textShadow: '0px 1px 0px rgba(254, 196, 77, 0.6)',
    },
  },
};
